import { render, staticRenderFns } from "./VariablesView.vue?vue&type=template&id=789081b8&scoped=true"
import script from "./VariablesView.vue?vue&type=script&lang=js"
export * from "./VariablesView.vue?vue&type=script&lang=js"
import style0 from "./VariablesView.vue?vue&type=style&index=0&id=789081b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789081b8",
  null
  
)

export default component.exports